import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import auth from '@/store/modules/auth';
import cafe24 from '@/store/modules/cafe24';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        // art,
        auth,
        // user,
        cafe24,
    },
    plugins: [new VuexPersistence({
        storage: window.sessionStorage,
    }).plugin],
});
